// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/otc-desk-img/otcbnrbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/otc-desk-img/otcbnrbg_light.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/otc-desk-img/otc_deskbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/images/otc-desk-img/otc_deskbg_light.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   OTC DESK STYLES - 100% PIXEL PERFECT TO USER SCREENSHOT
   ========================================================================== */

.otc-desk-page {
    background-color: #12151B;
    color: #ffffff;
    padding: 0;
    position: relative;
    overflow-x: hidden;
    min-height: 100vh;
}

body.light_theme .otc-desk-page {
    background-color: #f8fafc;
    color: #0f172a;
}

.otc-container {
    width: 1480px;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 999;
}

.gold-text {
    color: #D5A760;
    display: inline-block;
    font-weight: 700;
}

.hero-gold-text {
    color: #D5A760;
    display: inline-block;
    font-weight: 700;
}

/* ==========================================================================
   1. HERO SECTION WITH 3 CONCENTRIC GLOWING DOMES & 3 BADGES
   ========================================================================== */

.otc_desk_hero_s {
    position: relative;
    width: 100%;
    min-height: 720px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center top;
    background-size: 1920px auto;
    background-color: #12151B;
    overflow: hidden;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.otc_desk_hero_s::before {
    position: absolute;
    width: 58%;
    height: 350px;
    background: #171a1f;
    bottom: -80px;
    left: 50%;
    transform: translateX(-50%);
    content: "";
    z-index: 666;
    filter: blur(50px);
}

body.light_theme .otc_desk_hero_s::before {
    background: #f7f7f7;
}

body.light_theme .otc_desk_hero_s {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center top;
    background-size: 1920px auto;
}

.otc-hero-badges-wrapper {
    position: absolute;
    top: 190px;
    left: calc(50% - 425px);
    width: 840px;
    height: 820px;
    border-radius: 50%;
    pointer-events: none;
    z-index: 2;
    animation: otcOrbitSpin 25s linear infinite;
    transform-origin: center center;
    will-change: transform;
}

.otc-hero-badges-wrapper:has(.otc-hero-badge:hover) {
    animation-play-state: paused;
}

.otc-hero-badge {
    position: absolute;
    width: 80px;
    height: 80px;
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(-50%, -50%);
    pointer-events: auto;
    z-index: 5;
    animation: otcBadgeCounterSpin 40s linear infinite;
    transform-origin: center center;
    will-change: transform;
    transition: filter 0.3s ease;
}

.otc-hero-badge:hover {
    animation-play-state: paused;
    filter: drop-shadow(0 0 25px rgba(254, 203, 72, 0.95));
}

.otc-hero-badge img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 50%;
    display: block;
    pointer-events: none;
    transition: transform 0.3s ease, filter 0.3s ease;
}

.oct_bnr_img {
    max-width: 1230px;
    position: absolute;
    top: 0px;
}

.oct_bottom_img {
    position: absolute;
    bottom: 0px;
    z-index: 333;
    max-height: 300px;
}

.otc-hero-badge:hover img {
    transform: scale(1.12);
    filter: brightness(1.2);
}

.otc-hero-badge.badge-top {
    left: 50%;
    top: 0px;
}

.otc-hero-badge.badge-left {
    left: calc(50% - 320px);
    top: 150px;
}

.otc-hero-badge.badge-right {
    left: calc(50% + 320px);
    top: 150px;
}

/* Orbit 360deg Slow Motion Circular Rotation */
@keyframes otcOrbitSpin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* Counter-spin so icons remain upright as they orbit */
@keyframes otcBadgeCounterSpin {
    0% {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    100% {
        transform: translate(-50%, -50%) rotate(-360deg);
    }
}

.otc-hero-content {
    max-width: 1100px;
    margin: 380px auto 220px auto;
    position: relative;
    z-index: 999;
}

.otc-hero-title {
    font-size: 74px;
    font-weight: 700;
    line-height: 1.1;
    color: #ffffff;
    margin: 0 0 16px 0;
    letter-spacing: -0.4px;
}

body.light_theme .otc-hero-title {
    color: #0f172a;
}

.otc-hero-desc {
    font-size: 25px;
    color: #B9BCC0;
    line-height: 1.4;
    max-width: 1050px;
    margin: 22px auto 24px auto;
}

body.light_theme .otc-hero-desc {
    color: #64748b;
}

.otc-hero-btns {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 22px;
    padding-top: 6px;
}

.otc-hero-btns a,
.otc-hero-btns button {
    font-size: 24px;
    font-weight: 400;
    min-height: 66px;
    padding: 15px 36px;
    border-radius: 50px;
    text-decoration: none;
    transition: all 0.25s ease;
}

.btn-primary-gold {
    background: #D1AA67;
    color: #ffffff !important;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: none;
    cursor: pointer;

}

.btn-primary-gold:hover {
    background: #C79545;
    transform: translateY(-2px);
    box-shadow: 0 6px 22px rgba(217, 168, 89, 0.45);
    color: #ffffff !important;
}

.btn-secondary-dark {
    background: rgb(82 82 82 / 85%);
    color: #D0D4DF !important;
    border: 1px solid rgb(255 255 255 / 12%);
    text-decoration: none;
    display: inline-flex;
    align-items: center;
}

body.light_theme .btn-secondary-dark {
    background: #ffffff;
    color: #334155 !important;
    border: 1px solid #cbd5e1;
}

.btn-secondary-dark:hover {
    background: #4A5162;
    color: #ffffff !important;
}

/* ==========================================================================
   2. COMPLETE TRADING SUITE
   ========================================================================== */

.otc-trading-suite-section {
    padding: 100px 0 120px;
    position: relative;
    background-color: #171B20;
}

body.light_theme .otc-trading-suite-section {
    background-color: #ffffff;
}

.otc-suite-header {
    text-align: center;
    margin-bottom: 34px;
}

.otc-suite-title {
    font-size: 60px;
    font-weight: 500;
    /* color: #ffffff; */
    margin: 0;
    letter-spacing: 0;
}

body.light_theme .otc-suite-title {
    color: #0f172a;
}

.otc-quote-works-grid {
    display: grid;
    grid-template-columns: 1.10fr 0.90fr;
    gap: 32px;
    max-width: 100%;
    margin: 0 auto;
    align-items: stretch;
}

.otc-card {
    background: rgb(255 255 255 / 10%);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 20px;
    padding: 24px;
    box-shadow: inset 0 4px 20px rgba(0, 0, 0, 0.3);
}

body.light_theme .otc-card {
    background: rgb(0 0 0 / 5%);
    border-color: #eff4fb;
    box-shadow: inset 0 10px 30px rgba(0, 0, 0, 0.07);
}

.otc-card-title {
    font-size: 30px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 22px 0;
}

body.light_theme .otc-card-title {
    color: #0f172a;
}

/* Styled Buy / Sell Tab matching exact screenshot */
.quote-tabs-container {
    display: flex;
    background-color: #4C4E51;
    border-radius: 50px;
    height: 46px;
    position: relative;
    padding: 0;
    margin-bottom: 20px;
    overflow: hidden;
}

body.light_theme .quote-tabs-container {
    background-color: #e2e8f0;
}

.quote-tab-pill {
    border: none;
    font-size: 17px;
    cursor: pointer;
    transition: all 0.2s ease;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
}

/* Buy tab is active */
.quote-tabs-container.is-buy .quote-tab-pill.buy {
    width: 53%;
    background: linear-gradient(180deg, #3EE49A 0%, #20BF7A 100%);
    color: #ffffff;
    font-weight: 700;
    border-radius: 50px 0 0 50px;
    clip-path: polygon(0 0, calc(100% - 14px) 0, 100% 100%, 0 100%);
    padding-right: 8px;
    box-shadow: inset 0 7px 3px rgb(255 255 255 / 30%);
    z-index: 2;
}

.quote-tabs-container.is-buy .quote-tab-pill.sell {
    width: 47%;
    color: #9CA3AF;
    font-weight: 700;
    background: transparent;
    border-radius: 0 50px 50px 0;
    z-index: 1;
}

/* Sell tab is active */
.quote-tabs-container.is-sell .quote-tab-pill.buy {
    width: 47%;
    color: #8A919E;
    font-weight: 500;
    background: transparent;
    border-radius: 50px 0 0 50px;
    z-index: 1;
}

.quote-tabs-container.is-sell .quote-tab-pill.sell {
    width: 53%;
    background: linear-gradient(180deg, #FF6666 0%, #EE3F3F 100%);
    color: #ffffff;
    font-weight: 700;
    border-radius: 0 50px 50px 0;
    clip-path: polygon(14px 0, 100% 0, 100% 100%, 0 100%);
    padding-left: 8px;
    box-shadow: inset 0 7px 3px rgb(255 255 255 / 20%);
    z-index: 2;
}

/* Form Input Groups */
.quote-pair-price-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
}

.quote-pair-price-row .otc-pair-picker {
    flex: 1 1;
    min-width: 0;
    margin: 0;
}

.quote-live-price {
    display: flex;
    align-items: baseline;
    gap: 8px;
    flex-shrink: 0;
}

.quote-live-last {
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
}

body.light_theme .quote-live-last {
    color: #0f172a;
}

.quote-live-change {
    font-size: 14px;
    font-weight: 600;
}

.quote-live-change.is-up {
    color: #2BC287
}

.quote-live-change.is-down {
    color: #ff5d5d;
}

.quote-amount-card {
    gap: 8px;
}

.quote-amount-input {
    flex: 1 1;
    width: 100%;
    min-width: 0;
    text-align: left;
    cursor: text;
}

.quote-amount-card {
    cursor: text;
}

.quote-field-input.quote-amount-input::placeholder {
    color: rgba(255, 255, 255, 0.38);
    font-weight: 400;
}

.quote-field-input.quote-amount-input:focus::placeholder {
    color: transparent;
}

body.light_theme .quote-field-input.quote-amount-input::placeholder {
    color: #94a3b8;
}

.quote-amount-approx {
    margin: 8px 2px 0;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.3;
    color: #d7dbe6;
}

.quote-amount-approx span+span {
    margin-left: 0.75rem;
}

body.light_theme .quote-amount-approx {
    color: #334155;
}

.quote-amount-side {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.quote-amount-side .creative-dropdown-trigger {
    background: transparent;
    padding: 0;
    height: auto;
}

.quote-amount-side .creative-dropdown-menu {
    right: 0;
    left: auto;
    min-width: 180px;
}

.quote-field-group {
    margin-bottom: 16px;
}

.quote-field-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 7px;
}

.quote-field-label {
    font-size: 15px;
    color: #848992;
    font-weight: 500;
}

body.light_theme .quote-field-label {
    color: #64748b;
}

.quote-avail-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
}

.quote-avail-text {
    font-size: 12px;
    color: #7A8293;
}

.otc-balance-tip {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.otc-balance-tip__icon {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: help;
}

.otc-balance-tip__text {
    display: none;
    position: absolute;
    right: 0;
    bottom: calc(100% + 8px);
    width: 230px;
    padding: 8px 10px;
    border-radius: 8px;
    background: #ffffff;
    color: #0f172a;
    border: 1px solid #e2e8f0;
    font-size: 11px;
    line-height: 1.4;
    font-weight: 600;
    text-align: left;
    white-space: normal;
    z-index: 8;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.18);
    pointer-events: none;
}

.otc-balance-tip__icon:hover .otc-balance-tip__text {
    display: block;
}

.otc-inline-max-btn {
    background: none;
    border: none;
    color: #D5A760;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    padding: 0;
}

.otc-inline-max-btn:hover {
    text-decoration: underline;
}

.quote-input-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgb(255 255 255 / 10%);
    box-shadow: inset 0 3px 7px rgb(0 0 0 / 15%);
    border: 1px solid #686868;
    border-radius: 50px;
    padding: 0 14px;
    height: 48px;
    transition: border-color 0.2s ease;
}

body.light_theme .quote-input-card {
    background: rgb(0 0 0 / 5%);
    border-color: #e7e7e7;
    box-shadow: inset 0 3px 7px rgb(0 0 0 / 5%);
}

.quote-input-card:focus-within {
    border-color: rgba(213, 167, 96, 0.5);
}

.quote-input-coin {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.otc-coin-label {
    display: flex;
    align-items: center;
    gap: 6px;
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
}

.quote-field-input {
    border: none;
    background: transparent;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    outline: none;
    /* width: 100%; */
    font-family: inherit;
}

body.light_theme .quote-field-input {
    color: #0f172a;
}

.quote-field-input::placeholder {
    color: #ffffff;
}

.quote-field-error,
.quote-field-warning,
.quote-field-hint {
    margin: 6px 8px 0;
    font-size: 12px;
    line-height: 1.4;
}

.quote-field-error {
    color: #f07178;
}

.quote-field-warning {
    color: #e6b450;
}

body.light_theme .quote-field-warning {
    color: #9a6b00;
}

.quote-field-hint {
    color: #7A8293;
}

/* Rate Row */
.quote-rate-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    margin: 14px 2px 20px;
}

.quote-rate-label {
    color: #7A8293;
    font-weight: 500;
}

.quote-rate-val {
    color: #D8DCE6;
    font-weight: 500;
    font-family: inherit;
}

body.light_theme .quote-rate-val {
    color: #0f172a;
}

/* Submit Button */
.otc-desk-closed {
    margin: 0 0 12px;
    color: #f0c674;
    font-size: 13px;
    line-height: 1.5;
}

.btn-request-quote {
    width: 100%;
    height: 50px;
    background: #D1AA67;
    color: #ffffff !important;
    font-size: 17px;
    font-weight: 600;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    box-shadow: 0 4px 16px rgba(217, 168, 89, 0.25);
    transition: all 0.25s ease;
}

.btn-request-quote:hover {
    background: #C79545;
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(217, 168, 89, 0.35);
    color: #ffffff !important;
}

.btn-request-quote:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

/* How It Works Steps */
.works-steps-list {
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding-top: 6px;
}

.works-step-item {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 14px;
}

.works-step-num {
    width: 36px;
    height: 36px;
    min-width: 36px;
    border-radius: 50%;
    background: rgb(209 170 103 / 20%);
    /* border: 1px solid rgba(213, 167, 96, 0.35); */
    color: #D1AA67;
    font-size: 15px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
}

.works-step-text h4 {
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
    margin: 0 0 3px 0;
}

body.light_theme .works-step-text h4 {
    color: #0f172a;
}

.works-step-text p {
    max-width: 96%;
    font-size: 15px;
    color: #9CA3AF;
    margin: 0;
    line-height: 1.45;
}

body.light_theme .works-step-text p {
    color: #64748b;
}

/* ==========================================================================
   3. WHY TRADE WITH AGCE OTC DESK?
   ========================================================================== */

.why-otc-section {
    position: relative;
    min-height: 638px;
    z-index: 666;
    display: flex;
    align-items: center;
    padding: 30px 0 35px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center bottom / cover;
    overflow: hidden;
}

body.light_theme .why-otc-section {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center bottom / cover;
}

.why-otc-title {
    font-size: 38px;
    font-weight: 600;
    color: #ffffff;
    text-align: left;
    margin: 0 0 26px 0;
}

body.light_theme .why-otc-title {
    color: #0f172a;
}

.why-otc-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
}

.why-otc-card {
    background: rgb(255 255 255 / 10%);
    border: 1px solid rgb(255 252 248 / 10%);
    border-radius: 18px;
    padding: 22px;
    display: flex;
    align-items: flex-start;
    gap: 14px;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    transition: transform 0.25s ease, border-color 0.25s ease;
}

body.light_theme .why-otc-card {
    background: rgb(0 0 0 / 5%);
    border-color: #eff6fe;
}

.why-otc-card:hover {
    transform: translateY(-3px);
    border-color: rgba(213, 167, 96, 0.35);
}

.why-otc-icon-box {
    width: 45px;
    height: 45px;
    min-width: 45px;
    border-radius: 16px;
    background: rgb(209 170 103 / 25%);
    /* border: 1px solid rgba(213, 167, 96, 0.25); */
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.why-otc-icon-box img {
    width: 20px;
    height: 20px;
    object-fit: contain;
}

.why-otc-text h3 {
    font-size: 15px;
    font-weight: 700;
    color: #ffffff;
    margin: 0 0 5px 0;
}

body.light_theme .why-otc-text h3 {
    color: #0f172a;
}

.why-otc-text p {
    font-size: 13.5px;
    color: #AEAEAE;
    line-height: 1.45;
    margin: 0;
}

body.light_theme .why-otc-text p {
    color: #64748b;
}

/* ==========================================================================
   4. BUILT FOR TRADES THAT NEED MORE THAN AN EXCHANGE SCREEN
   ========================================================================== */

.built-trades-section {
    padding: 100px 0 75px;
    background-color: #171B20;
    position: relative;
}

body.light_theme .built-trades-section {
    background-color: #ffffff;
}

.built-trades-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
    margin-bottom: 48px;
}

.built-trades-left {
    flex: 1 1;
    max-width: 790px;
}

.built-trades-heading {
    font-size: 60px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1;
    margin: 0 0 18px 0;
}

body.light_theme .built-trades-heading {
    color: #0f172a;
}

.built-trades-desc {
    font-size: 21px;
    color: #8493A8;
    line-height: 1.6;
    margin: 0;
}

body.light_theme .built-trades-desc {
    color: #64748b;
}

.built-trades-right {
    max-width: 720px;
    flex-shrink: 0;
}

.built-trades-img {
    width: 100%;
    height: auto;
    object-fit: contain;
    border-radius: 14px;
}

.built-trades-features {
    max-width: 1160px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 40px;
}

.built-feature-card {
    background: transparent;
    padding: 0;
}

.built-feature-icon-wrapper {
    width: 60px;
    margin-bottom: 5px;
}

.built-feature-icon-wrapper img {
    object-fit: contain;
}

.built-feature-card h3 {
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
    margin: 0 0 6px 0;
    line-height: 1.35;
}

body.light_theme .built-feature-card h3 {
    color: #0f172a;
}

.built-feature-card p {
    font-size: 14px;
    color: #8493A8;
    line-height: 1.45;
    margin: 0;
}

body.light_theme .built-feature-card p {
    color: #64748b;
}

/* ==========================================================================
   5. RECENT COMPLETED TRADES TABLE
   ========================================================================== */

.recent-trades-section {
    padding: 48px 0 80px;
    background-color: #171B20;
    position: relative;
}

body.light_theme .recent-trades-section {
    background-color: #fff;
}

.trades-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.trades-header-row h2 {
    font-size: 38px;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
}

body.light_theme .trades-header-row h2 {
    color: #0f172a;
}

.view-all-link {
    font-size: 14px;
    color: #D1AA67;
    text-decoration: none;
    font-weight: 600;
    transition: color 0.2s ease;
}

.view-all-link:hover {
    color: #D5A760;
    text-decoration: underline;
}

.otc-trades-empty {
    margin: 0;
    padding: 48px 16px;
    text-align: center;
    color: #9ca3af;
    background: rgb(255 255 255 / 10%);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
}

body.light_theme .otc-trades-empty {
    color: #64748b;
    background: rgb(0 0 0 / 5%);
    border-color: #e2e8f0;
}

.otc-history-back {
    display: inline-block;
    margin-bottom: 8px;
}

.otc-history-count {
    color: #9ca3af;
    font-size: 14px;
}

.otc-history-pager {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 16px;
    color: #d1d5db;
    font-size: 13px;
}

.otc-history-pager button {
    border: none;
    background: #d1aa67;
    color: #fff;
    border-radius: 999px;
    padding: 8px 16px;
    font-weight: 600;
    cursor: pointer;
}

.otc-history-pager button:disabled {
    opacity: 0.45;
    cursor: default;
}

.trades-table-card {
    background: rgb(255 255 255 / 10%);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}

body.light_theme .trades-table-card {
    background: #ffffff;
    border-color: #e2e8f0;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
}

.trades-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
}

.trades-table th {
    background: #464B52;
    padding: 12px 22px;
    font-size: 13px;
    font-weight: 400;
    color: #9CA3AF;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

body.light_theme .trades-table th {
    background: #f8fafc;
    color: #64748b;
    border-bottom-color: #e2e8f0;
}

.trades-table td {
    padding: 16px 22px;
    font-size: 13px;
    color: #dfdfdf;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    vertical-align: middle;
}

.trades-table td.trade-pair-cell {
    color: #fff;
    font-weight: 500;
}

.trades-table td.trade-total-cell {
    color: #fff;
    font-weight: 500;
}

body.light_theme .trades-table td {
    color: #0f172a;
    border-bottom-color: #f1f5f9;
}

.trades-table tr:last-child td {
    border-bottom: none;
}

.badge-trade-type {
    display: inline-block;
    padding: 2px 11px;
    border-radius: 50px;
    font-size: 13.5px;
    font-weight: 700;
    text-align: center;
}

.badge-trade-type.buy {
    background-color: #D1FAE5;
    color: #059669;
}

.badge-trade-type.sell {
    background-color: #FEE2E2;
    color: #DC2626;
}

/* ==========================================================================
   CREATIVE DROPDOWN STYLING
   ========================================================================== */

.otc-pair-picker {
    width: 100%;
}

.otc-pair-picker .creative-dropdown-wrapper,
.otc-pair-picker .creative-dropdown-trigger {
    width: 100%;
}

.otc-pair-picker .creative-dropdown-trigger {
    justify-content: space-between;
}

.otc-pair-picker .creative-dropdown-menu {
    width: 100%;
    min-width: 100%;
}

.otc-landing-pair-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 0;
    background: transparent;
    color: #fff;
    font-size: 17px;
    font-weight: 600;
    padding: 2px 0;
    cursor: pointer;
}

.otc-pair-picker .orderbook-table td {
    font-size: 13px;
}

body.light_theme .otc-landing-pair-btn {
    color: #0f172a;
}

.otc-pair-picker {
    position: relative;
    overflow: visible;
}

.otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open {
    position: absolute !important;
    left: 0 !important;
    right: auto !important;
    top: calc(100% + 8px) !important;
    margin: 0 !important;
    width: min(440px, calc(100vw - 32px)) !important;
    height: auto !important;
    max-height: min(520px, calc(100vh - 160px)) !important;
    overflow: auto !important;
    display: flex !important;
    flex-direction: column !important;
    z-index: 100000 !important;
    background-color: #2b313c;
}

.otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open .spotLists {
    display: block !important;
    height: auto !important;
    min-height: 240px !important;
    max-height: none !important;
    max-width: none !important;
    width: 100% !important;
    overflow: visible !important;
}

.otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open .table-responsive {
    min-height: 160px !important;
    max-height: 320px !important;
    height: auto !important;
    overflow: auto !important;
}

body.light_theme .otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open {
    background-color: #f2f2f2;
    border-color: #e7e7e7;
}

body.light_theme .otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open .spotLists {
    background: #f2f2f2;
}

body.light_theme .otc-desk-page .otc-pair-picker .orderbook-table th {
    background: #f2f2f2;
}

.otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open {
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 16px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
    background: #171b20;
}

.otc-desk-page .otc-pair-picker .spot-list-search .ivu-input {
    background: rgb(255 255 255 / 10%);
    border: 1px solid #686868;
    border-radius: 10px;
}

.otc-desk-page .otc-pair-picker .spot-list-search .ivu-input input {
    color: #ffffff;
}

.otc-desk-page .otc-pair-picker .spot-list-search i,
.otc-desk-page .otc-pair-picker ul.favorites_list_tabs li button {
    color: #9ca3af;
}

.otc-desk-page .otc-pair-picker ul.favorites_list_tabs li button.active {
    color: #ffffff;
}

.otc-desk-page .otc-pair-picker ul.favorites_list_tabs li button.active:before,
.otc-desk-page .otc-pair-picker ul.favorites_list_tabs li button:before {
    background-color: #d5a760;
}

.otc-desk-page .otc-pair-picker .orderbook-table th {
    color: #9ca3af;
    background: #171a20;
}

.otc-desk-page .otc-pair-picker .pair-color,
.otc-desk-page .otc-pair-picker .orderbook-table td {
    color: #ffffff;
}

.otc-desk-page .otc-pair-picker .tokensubcnt {
    color: #9ca3af;
}

.otc-desk-page .otc-pair-picker .text-green {
    color: #2bc287;
}

.otc-desk-page .otc-pair-picker .text-danger {
    color: #f74b60;
}

.otc-desk-page .otc-pair-picker tr.active {
    background: rgba(213, 167, 96, 0.12);
}

.otc-desk-page .otc-pair-picker .ri-star-fill {
    color: #d5a760;
}

body.light_theme .otc-desk-page .otc-pair-picker .spot-list-search .ivu-input {
    background: rgb(0 0 0 / 4%);
    border-color: #e7e7e7;
}

body.light_theme .otc-desk-page .otc-pair-picker .spot-list-search .ivu-input input,
body.light_theme .otc-desk-page .otc-pair-picker .pair-color,
body.light_theme .otc-desk-page .otc-pair-picker .orderbook-table td,
body.light_theme .otc-desk-page .otc-pair-picker ul.favorites_list_tabs li button.active {
    color: #0f172a;
}

body.light_theme .otc-desk-page .otc-pair-picker .orderbook-table th,
body.light_theme .otc-desk-page .otc-pair-picker .tokensubcnt,
body.light_theme .otc-desk-page .otc-pair-picker ul.favorites_list_tabs li button {
    color: #64748b;
}

.creative-dropdown-wrapper {
    position: relative;
    display: inline-block;
    z-index: 20;
}

.creative-dropdown-wrapper.is-open {
    z-index: 1000;
}

.creative-dropdown-trigger {
    display: flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: transparent;
    outline: none;
    cursor: pointer;
    padding: 2px 4px 2px 0;
    border-radius: 6px;
}

.coin-trigger-content {
    display: flex;
    align-items: center;
    gap: 6px;
}

.coin-symbol-text {
    font-size: 17px;
    font-weight: 600;
    color: #ffffff;
}

body.light_theme .coin-symbol-text {
    color: #0f172a;
}

.dropdown-chevron {
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    stroke: #c1c1c1;
}

.creative-dropdown-wrapper .dropdown-chevron path {
    stroke: #c1c1c1;
}

.dropdown-chevron.rotate {
    transform: rotate(180deg);
    border: none;
    width: auto;
}

.creative-dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    min-width: 200px;
    background-color: #1E232E !important;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5);
    padding: 6px;
    z-index: 99999 !important;
    max-height: 260px;
    overflow-y: auto;
}

body.light_theme .creative-dropdown-menu {
    background-color: #ffffff !important;
    border-color: #e2e8f0;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.creative-dropdown-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.creative-dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.08);
}

body.light_theme .creative-dropdown-item:hover {
    background-color: #f1f5f9;
}

.creative-dropdown-item.selected {
    background-color: rgba(213, 167, 96, 0.15);
}

.dropdown-item-left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.coin-name-block {
    display: flex;
    flex-direction: column;
}

.coin-sym {
    font-size: 13.5px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.2;
}

body.light_theme .coin-sym {
    color: #0f172a;
}

.coin-subname {
    font-size: 11.5px;
    color: #7A8293;
    font-weight: 500;
}

.otc-coin-icon-img {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    object-fit: cover;
}

/* ==========================================================================
   EXECUTION VIEW (/otc/rfq) PRESERVATION & ENHANCEMENTS
   ========================================================================== */

.otc-desk-trade {
    padding: 8px 8px 16px;
    min-height: calc(100vh - 58px);
    background: #0b0e11;
}

.otc-trade-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 360px;
    grid-template-rows: 680px auto;
    column-gap: 8px;
    row-gap: 0;
    align-items: start;
}

.otc-trade-chart {
    height: 680px;
    min-height: 680px;
    max-height: 680px;
    background: #0b0e11;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    border: 1px solid #1e2329;
}

.otc-desk-trade .otc-trade-chart #TVChartContainer,
.otc-desk-trade .otc-trade-chart #TVChartContainer iframe {
    height: 680px !important;
    min-height: 680px !important;
    max-height: 680px !important;
    width: 100%;
}

.otc-trade-side {
    grid-column: 2;
    grid-row: 1 / span 2;
    margin: 0;
    max-height: calc(100vh - 80px);
    overflow: auto;
    border: 1px solid #1e2329;
    border-radius: 4px;
    background: #161a1e;
    padding: 16px;
}

.otc-exec-title {
    font-size: 16px;
    margin-bottom: 12px;
}

.otc-current-ticket {
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid #2b3139;
}

.otc-current-ticket h3 {
    font-size: 14px;
    margin: 0 0 10px;
    color: #eaecef;
}

.otc-ticket-row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    font-size: 12px;
    color: #848e9c;
    padding: 6px 0;
}

.otc-ticket-row span:last-child {
    color: #eaecef;
    text-align: right;
}

.otc-bottom-panel {
    grid-column: 1;
    margin: 0;
    background: #181a20;
    border: 1px solid #1e2329;
    border-radius: 4px;
}

.otc-bottom-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    border-bottom: 1px solid #2b3139;
}

.otc-bottom-tabs {
    display: flex;
    gap: 18px;
    list-style: none;
    margin: 0;
    padding: 0 16px;
    border-bottom: none;
}

.otc-bottom-tabs li button {
    position: relative;
    border: none;
    background: transparent;
    color: #848e9c;
    font-size: 14px;
    font-weight: 500;
    padding: 14px 2px 12px;
    cursor: pointer;
}

.otc-bottom-tabs li.active button {
    color: #eaecef;
}

.otc-bottom-tabs li.active button::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 28px;
    height: 3px;
    border-radius: 3px;
    background: #D5A760;
    transform: translateX(-50%);
}

.otc-bottom-note {
    margin: 0 16px 12px 0;
    font-size: 12px;
    color: #848e9c;
}

.otc-bottom-empty {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    color: #848e9c;
    font-size: 13px;
}

.otc-bottom-table {
    width: 100%;
    border-collapse: collapse;
}

.otc-bottom-table th,
.otc-bottom-table td {
    padding: 10px 16px;
    font-size: 12px;
    text-align: left;
    white-space: nowrap;
}

.otc-bottom-table th {
    color: #848e9c;
    font-weight: 500;
    border-bottom: 1px solid #2b3139;
}

.otc-bottom-table td {
    color: #eaecef;
}

.otc-bottom-table td.is-buy {
    color: #20BF7A;
}

.otc-bottom-table td.is-sell {
    color: #EF4444;
}

.otc-desk-status {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    background: #2b3139;
    color: #eaecef;
    font-size: 11px;
}

.otc-desk-status.is-open,
.otc-desk-status.is-quoted {
    background: rgba(213, 167, 96, 0.15);
    color: #D5A760;
}

.otc-desk-status.is-accepted,
.otc-desk-status.is-settled,
.otc-desk-status.is-completed {
    background: rgba(32, 191, 122, 0.15);
    color: #20BF7A;
}

.otc-card-quote {
    background: #181C26;
    border: 1px solid rgba(255, 255, 255, 0.08);
}

.otc-card-quote .otc-card-title {
    color: #ffffff;
    font-size: 18px;
}

.otc_tradingpage .midgraph_col .treade_card_header.tch_main_tab {
    display: none;
}

.otc-quote-row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    font-size: 13px;
    color: #848E9C;
    padding: 4px 0;
}

.otc-quote-row span:last-child {
    color: #ffffff;
    font-weight: 600;
}

.otc-countdown {
    font-size: 14px;
    font-weight: 700;
    color: #D5A760;
    margin: 8px 0 16px;
}

.otc-countdown.expired {
    color: #EF4444;
}

/* ==========================================================================
   RESPONSIVE DESIGN
   ========================================================================== */

@media (max-width: 1550px) {


    .otc-hero-badges-wrapper {
        width: 700px;
        height: 700px;
        left: calc(50% - 350px);
        top: 170px;
    }

    .otc-hero-title {
        font-size: 54px;
    }

    .otc-hero-desc {
        font-size: 21px;
        max-width: 900px;
    }

    .otc-hero-btns a {
        font-size: 18px;
        padding: 12px 32px;
    }

    .otc-hero-btns a,
    .otc-hero-btns button {
        font-size: 18px;
        padding: 12px 32px;
        min-height: 54px;
    }

    .otc-suite-title {
        font-size: 48px;
    }

    .otc-container {
        width: 90%;
    }

    .built-trades-heading {
        font-size: 48px;
    }

    .otc-hero-badge.badge-top {
        top: 0px;
        left: 50%;
    }

    .otc-hero-badge.badge-left {
        left: calc(50% - 275px);
        top: 130px;
    }

    .otc-hero-badge.badge-right {
        left: calc(50% + 275px);
        top: 130px;
    }

    .otc-hero-content {
        margin-top: 340px;
    }

    .oct_bnr_img {
        max-width: 1010px;
    }
}

@media (max-width: 1200px) {
    .otc_desk_hero_s {
        background-size: 1400px auto;
        min-height: 580px;
    }

    .otc-hero-badges-wrapper {
        width: 580px;
        height: 580px;
        left: calc(50% - 290px);
        top: 140px;
    }

    .otc-hero-badge.badge-top {
        top: 0px;
        left: 50%;
    }

    .otc-hero-badge.badge-left {
        left: calc(50% - 225px);
        top: 110px;
    }

    .otc-hero-badge.badge-right {
        left: calc(50% + 225px);
        top: 110px;
    }

    .otc-hero-content {
        margin-top: 300px;
    }

    .otc-container {
        width: 100%;
        padding: 0 20px;
    }

    .why-otc-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .built-trades-left {
        max-width: 100%;
    }

    .built-trades-desc {
        margin: 0 auto;
    }

    .built-trades-section {
        padding: 50px 0 60px;
    }

    .built-trades-heading {
        font-size: 40px;
    }

    .built-trades-heading br {
        display: none;
    }

    .built-trades-heading .gold-text {
        display: inline;
        padding-left: 8px;
    }

    .built-trades-features {
        grid-template-columns: repeat(2, 1fr);
    }

    .otc-trading-suite-section {
        padding: 50px 0 70px;
    }

    .why-otc-title {
        font-size: 32px;
    }

    .oct_bnr_img {
        max-width: 800px;
    }

    .otc-hero-title {
        font-size: 44px;
    }

    .otc-hero-desc {
        font-size: 18px;
        max-width: 700px;
    }

    .otc-suite-title {
        font-size: 38px;
    }

    .why-otc-section {
        min-height: 490px;
    }
}

@media (max-width: 1024px) {

    .oct_bnr_img {
        max-width: 600px;
    }

    .otc-hero-content {
        margin-top: 200px;
    }

    .otc-hero-title {
        font-size: 32px;
    }

    .otc-hero-desc {
        font-size: 16px;
        max-width: 530px;
    }

    .otc-hero-btns a {
        font-size: 15px;
        padding: 9px 26px;
    }

    .otc-hero-btns a,
    .otc-hero-btns button {
        font-size: 15px;
        padding: 9px 26px;
        min-height: 46px;
    }

    .otc_desk_hero_s {
        background-size: contain;
        min-height: 100%;
    }

    .otc-hero-badges-wrapper {
        width: 450px;
        height: 450px;
        left: calc(50% - 226px);
        top: 110px;
    }

    .otc-suite-title {
        font-size: 32px;
    }

    .otc-card-title {
        font-size: 24px;
    }

    .why-otc-title {
        font-size: 26px;
    }

    .built-trades-heading {
        font-size: 32px;
    }

    .built-trades-desc {
        font-size: 16px;
    }

    .built-trades-right {
        max-width: 450px;
    }

    .trades-header-row h2 {
        font-size: 30px;
    }

}

@media (max-width: 991px) {

    .oct_bnr_img {
        max-width: 450px;
    }

    .otc-landing-pair-btn {
        font-size: 15px;
    }

    .quote-live-last {
        font-size: 15px;
    }

    .coin-symbol-text {
        font-size: 15px;
    }

    .quote-field-input {
        font-size: 15px;
    }

    .otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open .spotLists {
        top: 0px;
        left: 0px;
    }

    .otc_desk_hero_s {
        min-height: 100%;
    }

    .otc-hero-badges-wrapper {
        width: 360px;
        height: 360px;
        left: calc(50% - 180px);
        top: 70px;
    }

    .otc-hero-btns {
        gap: 14px;
        padding-top: 0px;
    }

    .otc-hero-badge {
        width: 44px;
        height: 44px;
    }

    .otc-hero-badge img {
        width: 100%;
        height: 100%;
    }

    .otc-hero-badge.badge-top {
        top: 0px;
        left: 50%;
    }

    .otc-hero-badge.badge-left {
        left: calc(50% - 140px);
        top: 65px;
    }

    .otc-hero-badge.badge-right {
        left: calc(50% + 140px);
        top: 65px;
    }

    .otc-hero-content {
        margin-top: 140px;
        margin-bottom: 60px;
    }

    .otc-hero-title {
        font-size: 26px;
    }


    .built-feature-icon-wrapper {
        margin: 0 auto 12px auto;
    }

    .built-trades-heading {
        font-size: 26px;
    }

    .otc-suite-title {
        font-size: 24px;
    }

    .trades-table-card {
        border-radius: 12px;
        overflow-x: auto;
    }

    .trades-table th,
    .trades-table td {
        padding: 12px 14px;
        font-size: 13px;
        white-space: nowrap;
    }

    .otc-trade-layout {
        grid-template-columns: 1fr;
        grid-template-rows: auto;
    }

    .otc-trade-side {
        grid-column: 1;
        grid-row: auto;
        max-height: none;
    }

    .otc-bottom-panel {
        grid-column: 1;
    }

    .otc-trade-chart,
    .otc-desk-trade .otc-trade-chart #TVChartContainer,
    .otc-desk-trade .otc-trade-chart #TVChartContainer iframe {
        height: 420px !important;
        min-height: 420px !important;
        max-height: 420px !important;
    }
}

@media (max-width: 767px) {

    .why-otc-grid {
        grid-template-columns: 1fr;
    }

    .built-trades-features {
        grid-template-columns: 1fr;
        text-align: center;
    }

    .oct_bnr_img {
        max-width: 80%;
    }

    .otc-hero-content {
        margin-top: 40px;
        margin-bottom: 30px;
    }

    .otc-hero-title {
        font-size: 24px;
    }

    .otc-hero-desc {
        font-size: 14px;
        max-width: 530px;
        margin: 15px auto 16px auto;
    }

    .otc-hero-btns a {
        font-size: 14px;
        padding: 9px 22px;
    }

    .otc-hero-btns a,
    .otc-hero-btns button {
        font-size: 14px;
        padding: 9px 22px;
        min-height: 38px;
    }

    .otc-trading-suite-section {
        padding: 35px 0 30px;
    }

    .otc-suite-header {
        margin-bottom: 18px;
    }

    .coin-symbol-text {
        font-size: 13px;
    }

    .quote-field-input {
        font-size: 13px;
    }

    .otc-card-title {
        font-size: 20px;
        margin: 0px 0px 12px;
    }

    .otc-card {
        padding: 20px;
    }

    .quote-rate-row {
        font-size: 13px;
    }

    .btn-request-quote {
        height: 42px;
        font-size: 14px;
    }

    .works-step-text h4 {
        font-size: 16px;
    }

    .works-step-text p {
        max-width: 100%;
        font-size: 14px;
    }

    .why-otc-title {
        font-size: 22px;
        margin-bottom: 15px;
        text-align: center;
    }

    .built-trades-top {
        flex-direction: column;
        gap: 18px;
        margin-bottom: 20px;
    }

    .built-trades-left {
        text-align: center;
    }

    .built-trades-heading {
        font-size: 22px;
    }

    .built-trades-section {
        padding: 30px 0 40px;
    }

    .built-feature-card h3 {
        font-size: 16px;
    }

    .built-trades-features {
        gap: 24px;
    }

    .trades-header-row h2 {
        font-size: 22px;
    }

    .view-all-link {
        font-size: 12px;
        text-align: right;
    }

    .recent-trades-section {
        padding: 30px 0 40px;
    }

    .otc-hero-badges-wrapper {
        width: 270px;
        height: 300px;
        left: calc(50% - 133px);
        top: 25px;
    }

    .quote-tab-pill {
        font-size: 15px;
    }

    .otc_desk_hero_s::before {
        width: 100%;
        height: 120px;
        bottom: -30px;
        filter: blur(10px);
    }

    .otc_desk_hero_s {
        background-size: cover;
    }

    .otc-quote-works-grid {
        grid-template-columns: 1fr;
        gap: 24px;
    }

}

@media (max-width: 767px) {

    .otc-suite-title {
        font-size: 22px;
    }

}

@media (max-width: 580px) {

    .otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open {
        width: 280px !important;
    }

    .otc-landing-pair-btn {
        font-size: 14px;
    }

    .quote-live-last {
        font-size: 13px;
    }

    .quote-live-change {
        font-size: 13px;
    }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/OtcDesk/otc-desk.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;IACI,yBAAyB;IACzB,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;+EAE+E;;AAE/E;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,wEAA2F;IAC3F,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wEAAiG;IACjG,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,2CAA2C;IAC3C,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,oBAAoB;IACpB,UAAU;IACV,kDAAkD;IAClD,+BAA+B;IAC/B,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,sDAAsD;AAC1D;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,UAAU;AACd;;AAEA,+CAA+C;AAC/C;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,uDAAuD;AACvD;IACI;QACI,6CAA6C;IACjD;;IAEA;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,eAAe;;AAEnB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,+CAA+C;IAC/C,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,wCAAwC;IACxC,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;+EAE+E;;AAE/E;IACI,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,SAAS;IACT,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA,oDAAoD;AACpD;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI,UAAU;IACV,6DAA6D;IAC7D,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,+DAA+D;IAC/D,kBAAkB;IAClB,kDAAkD;IAClD,UAAU;AACd;;AAEA;IACI,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,4BAA4B;IAC5B,UAAU;AACd;;AAEA,uBAAuB;AACvB;IACI,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,UAAU;IACV,6DAA6D;IAC7D,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,qDAAqD;IACrD,iBAAiB;IACjB,kDAAkD;IAClD,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kCAAkC;IAClC,4CAA4C;IAC5C,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,+CAA+C;IAC/C,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,+CAA+C;IAC/C,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kCAAkC;IAClC,gDAAgD;IAChD,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;;+EAE+E;;AAE/E;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mFAAwG;IACxG,gBAAgB;AACpB;;AAEA;IACI,mFAA8G;AAClH;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kCAAkC;IAClC,0BAA0B;IAC1B,yDAAyD;AAC7D;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,kCAAkC;IAClC,gDAAgD;IAChD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;;+EAE+E;;AAE/E;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;;+EAE+E;;AAE/E;IACI,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kCAAkC;IAClC,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,kDAAkD;IAClD,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;+EAE+E;;AAE/E;IACI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,oBAAoB;IACpB,gDAAgD;IAChD,uBAAuB;IACvB,sDAAsD;IACtD,yBAAyB;IACzB,wBAAwB;IACxB,iCAAiC;IACjC,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wDAAwD;IACxD,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,gBAAgB;IAChB,oCAAoC;IACpC,0CAA0C;IAC1C,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;+EAE+E;;AAE/E;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;IAEI,wBAAwB;IACxB,4BAA4B;IAC5B,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,SAAS;IACT,8BAA8B;IAC9B,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;;;IAGI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;;+EAE+E;;AAE/E;;;IAGI;QACI,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,uBAAuB;QACvB,UAAU;IACd;;IAEA;QACI,uBAAuB;QACvB,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,UAAU;IACd;;IAEA;QACI,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,uBAAuB;QACvB,UAAU;IACd;;IAEA;QACI,uBAAuB;QACvB,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;;QAEI,kBAAkB;QAClB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,wBAAwB;IAC5B;;IAEA;QACI,cAAc;QACd,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;;;QAGI,wBAAwB;QACxB,4BAA4B;QAC5B,4BAA4B;IAChC;AACJ;;AAEA;;IAEI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,2BAA2B;IAC/B;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;AAEJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ","sourcesContent":["/* ==========================================================================\n   OTC DESK STYLES - 100% PIXEL PERFECT TO USER SCREENSHOT\n   ========================================================================== */\n\n.otc-desk-page {\n    background-color: #12151B;\n    color: #ffffff;\n    padding: 0;\n    position: relative;\n    overflow-x: hidden;\n    min-height: 100vh;\n}\n\nbody.light_theme .otc-desk-page {\n    background-color: #f8fafc;\n    color: #0f172a;\n}\n\n.otc-container {\n    width: 1480px;\n    max-width: 100%;\n    margin: 0 auto;\n    padding: 0 20px;\n    position: relative;\n    z-index: 999;\n}\n\n.gold-text {\n    color: #D5A760;\n    display: inline-block;\n    font-weight: 700;\n}\n\n.hero-gold-text {\n    color: #D5A760;\n    display: inline-block;\n    font-weight: 700;\n}\n\n/* ==========================================================================\n   1. HERO SECTION WITH 3 CONCENTRIC GLOWING DOMES & 3 BADGES\n   ========================================================================== */\n\n.otc_desk_hero_s {\n    position: relative;\n    width: 100%;\n    min-height: 720px;\n    background: url('../../../../public/images/otc-desk-img/otcbnrbg.jpg') no-repeat center top;\n    background-size: 1920px auto;\n    background-color: #12151B;\n    overflow: hidden;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.otc_desk_hero_s::before {\n    position: absolute;\n    width: 58%;\n    height: 350px;\n    background: #171a1f;\n    bottom: -80px;\n    left: 50%;\n    transform: translateX(-50%);\n    content: \"\";\n    z-index: 666;\n    filter: blur(50px);\n}\n\nbody.light_theme .otc_desk_hero_s::before {\n    background: #f7f7f7;\n}\n\nbody.light_theme .otc_desk_hero_s {\n    background: url('../../../../public/images/otc-desk-img/otcbnrbg_light.jpg') no-repeat center top;\n    background-size: 1920px auto;\n}\n\n.otc-hero-badges-wrapper {\n    position: absolute;\n    top: 190px;\n    left: calc(50% - 425px);\n    width: 840px;\n    height: 820px;\n    border-radius: 50%;\n    pointer-events: none;\n    z-index: 2;\n    animation: otcOrbitSpin 25s linear infinite;\n    transform-origin: center center;\n    will-change: transform;\n}\n\n.otc-hero-badges-wrapper:has(.otc-hero-badge:hover) {\n    animation-play-state: paused;\n}\n\n.otc-hero-badge {\n    position: absolute;\n    width: 80px;\n    height: 80px;\n    aspect-ratio: 1 / 1;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transform: translate(-50%, -50%);\n    pointer-events: auto;\n    z-index: 5;\n    animation: otcBadgeCounterSpin 40s linear infinite;\n    transform-origin: center center;\n    will-change: transform;\n    transition: filter 0.3s ease;\n}\n\n.otc-hero-badge:hover {\n    animation-play-state: paused;\n    filter: drop-shadow(0 0 25px rgba(254, 203, 72, 0.95));\n}\n\n.otc-hero-badge img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: 50%;\n    display: block;\n    pointer-events: none;\n    transition: transform 0.3s ease, filter 0.3s ease;\n}\n\n.oct_bnr_img {\n    max-width: 1230px;\n    position: absolute;\n    top: 0px;\n}\n\n.oct_bottom_img {\n    position: absolute;\n    bottom: 0px;\n    z-index: 333;\n    max-height: 300px;\n}\n\n.otc-hero-badge:hover img {\n    transform: scale(1.12);\n    filter: brightness(1.2);\n}\n\n.otc-hero-badge.badge-top {\n    left: 50%;\n    top: 0px;\n}\n\n.otc-hero-badge.badge-left {\n    left: calc(50% - 320px);\n    top: 150px;\n}\n\n.otc-hero-badge.badge-right {\n    left: calc(50% + 320px);\n    top: 150px;\n}\n\n/* Orbit 360deg Slow Motion Circular Rotation */\n@keyframes otcOrbitSpin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n/* Counter-spin so icons remain upright as they orbit */\n@keyframes otcBadgeCounterSpin {\n    0% {\n        transform: translate(-50%, -50%) rotate(0deg);\n    }\n\n    100% {\n        transform: translate(-50%, -50%) rotate(-360deg);\n    }\n}\n\n.otc-hero-content {\n    max-width: 1100px;\n    margin: 380px auto 220px auto;\n    position: relative;\n    z-index: 999;\n}\n\n.otc-hero-title {\n    font-size: 74px;\n    font-weight: 700;\n    line-height: 1.1;\n    color: #ffffff;\n    margin: 0 0 16px 0;\n    letter-spacing: -0.4px;\n}\n\nbody.light_theme .otc-hero-title {\n    color: #0f172a;\n}\n\n.otc-hero-desc {\n    font-size: 25px;\n    color: #B9BCC0;\n    line-height: 1.4;\n    max-width: 1050px;\n    margin: 22px auto 24px auto;\n}\n\nbody.light_theme .otc-hero-desc {\n    color: #64748b;\n}\n\n.otc-hero-btns {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 22px;\n    padding-top: 6px;\n}\n\n.otc-hero-btns a,\n.otc-hero-btns button {\n    font-size: 24px;\n    font-weight: 400;\n    min-height: 66px;\n    padding: 15px 36px;\n    border-radius: 50px;\n    text-decoration: none;\n    transition: all 0.25s ease;\n}\n\n.btn-primary-gold {\n    background: #D1AA67;\n    color: #ffffff !important;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    border: none;\n    cursor: pointer;\n\n}\n\n.btn-primary-gold:hover {\n    background: #C79545;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 22px rgba(217, 168, 89, 0.45);\n    color: #ffffff !important;\n}\n\n.btn-secondary-dark {\n    background: rgb(82 82 82 / 85%);\n    color: #D0D4DF !important;\n    border: 1px solid rgb(255 255 255 / 12%);\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n}\n\nbody.light_theme .btn-secondary-dark {\n    background: #ffffff;\n    color: #334155 !important;\n    border: 1px solid #cbd5e1;\n}\n\n.btn-secondary-dark:hover {\n    background: #4A5162;\n    color: #ffffff !important;\n}\n\n/* ==========================================================================\n   2. COMPLETE TRADING SUITE\n   ========================================================================== */\n\n.otc-trading-suite-section {\n    padding: 100px 0 120px;\n    position: relative;\n    background-color: #171B20;\n}\n\nbody.light_theme .otc-trading-suite-section {\n    background-color: #ffffff;\n}\n\n.otc-suite-header {\n    text-align: center;\n    margin-bottom: 34px;\n}\n\n.otc-suite-title {\n    font-size: 60px;\n    font-weight: 500;\n    /* color: #ffffff; */\n    margin: 0;\n    letter-spacing: 0;\n}\n\nbody.light_theme .otc-suite-title {\n    color: #0f172a;\n}\n\n.otc-quote-works-grid {\n    display: grid;\n    grid-template-columns: 1.10fr 0.90fr;\n    gap: 32px;\n    max-width: 100%;\n    margin: 0 auto;\n    align-items: stretch;\n}\n\n.otc-card {\n    background: rgb(255 255 255 / 10%);\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: 20px;\n    padding: 24px;\n    box-shadow: inset 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\nbody.light_theme .otc-card {\n    background: rgb(0 0 0 / 5%);\n    border-color: #eff4fb;\n    box-shadow: inset 0 10px 30px rgba(0, 0, 0, 0.07);\n}\n\n.otc-card-title {\n    font-size: 30px;\n    font-weight: 600;\n    color: #ffffff;\n    margin: 0 0 22px 0;\n}\n\nbody.light_theme .otc-card-title {\n    color: #0f172a;\n}\n\n/* Styled Buy / Sell Tab matching exact screenshot */\n.quote-tabs-container {\n    display: flex;\n    background-color: #4C4E51;\n    border-radius: 50px;\n    height: 46px;\n    position: relative;\n    padding: 0;\n    margin-bottom: 20px;\n    overflow: hidden;\n}\n\nbody.light_theme .quote-tabs-container {\n    background-color: #e2e8f0;\n}\n\n.quote-tab-pill {\n    border: none;\n    font-size: 17px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    outline: none;\n}\n\n/* Buy tab is active */\n.quote-tabs-container.is-buy .quote-tab-pill.buy {\n    width: 53%;\n    background: linear-gradient(180deg, #3EE49A 0%, #20BF7A 100%);\n    color: #ffffff;\n    font-weight: 700;\n    border-radius: 50px 0 0 50px;\n    clip-path: polygon(0 0, calc(100% - 14px) 0, 100% 100%, 0 100%);\n    padding-right: 8px;\n    box-shadow: inset 0 7px 3px rgb(255 255 255 / 30%);\n    z-index: 2;\n}\n\n.quote-tabs-container.is-buy .quote-tab-pill.sell {\n    width: 47%;\n    color: #9CA3AF;\n    font-weight: 700;\n    background: transparent;\n    border-radius: 0 50px 50px 0;\n    z-index: 1;\n}\n\n/* Sell tab is active */\n.quote-tabs-container.is-sell .quote-tab-pill.buy {\n    width: 47%;\n    color: #8A919E;\n    font-weight: 500;\n    background: transparent;\n    border-radius: 50px 0 0 50px;\n    z-index: 1;\n}\n\n.quote-tabs-container.is-sell .quote-tab-pill.sell {\n    width: 53%;\n    background: linear-gradient(180deg, #FF6666 0%, #EE3F3F 100%);\n    color: #ffffff;\n    font-weight: 700;\n    border-radius: 0 50px 50px 0;\n    clip-path: polygon(14px 0, 100% 0, 100% 100%, 0 100%);\n    padding-left: 8px;\n    box-shadow: inset 0 7px 3px rgb(255 255 255 / 20%);\n    z-index: 2;\n}\n\n/* Form Input Groups */\n.quote-pair-price-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.quote-pair-price-row .otc-pair-picker {\n    flex: 1;\n    min-width: 0;\n    margin: 0;\n}\n\n.quote-live-price {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.quote-live-last {\n    color: #ffffff;\n    font-size: 15px;\n    font-weight: 600;\n}\n\nbody.light_theme .quote-live-last {\n    color: #0f172a;\n}\n\n.quote-live-change {\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.quote-live-change.is-up {\n    color: #2BC287\n}\n\n.quote-live-change.is-down {\n    color: #ff5d5d;\n}\n\n.quote-amount-card {\n    gap: 8px;\n}\n\n.quote-amount-input {\n    flex: 1;\n    width: 100%;\n    min-width: 0;\n    text-align: left;\n    cursor: text;\n}\n\n.quote-amount-card {\n    cursor: text;\n}\n\n.quote-field-input.quote-amount-input::placeholder {\n    color: rgba(255, 255, 255, 0.38);\n    font-weight: 400;\n}\n\n.quote-field-input.quote-amount-input:focus::placeholder {\n    color: transparent;\n}\n\nbody.light_theme .quote-field-input.quote-amount-input::placeholder {\n    color: #94a3b8;\n}\n\n.quote-amount-approx {\n    margin: 8px 2px 0;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 1.3;\n    color: #d7dbe6;\n}\n\n.quote-amount-approx span+span {\n    margin-left: 0.75rem;\n}\n\nbody.light_theme .quote-amount-approx {\n    color: #334155;\n}\n\n.quote-amount-side {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.quote-amount-side .creative-dropdown-trigger {\n    background: transparent;\n    padding: 0;\n    height: auto;\n}\n\n.quote-amount-side .creative-dropdown-menu {\n    right: 0;\n    left: auto;\n    min-width: 180px;\n}\n\n.quote-field-group {\n    margin-bottom: 16px;\n}\n\n.quote-field-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 7px;\n}\n\n.quote-field-label {\n    font-size: 15px;\n    color: #848992;\n    font-weight: 500;\n}\n\nbody.light_theme .quote-field-label {\n    color: #64748b;\n}\n\n.quote-avail-wrap {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.quote-avail-text {\n    font-size: 12px;\n    color: #7A8293;\n}\n\n.otc-balance-tip {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.otc-balance-tip__icon {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    cursor: help;\n}\n\n.otc-balance-tip__text {\n    display: none;\n    position: absolute;\n    right: 0;\n    bottom: calc(100% + 8px);\n    width: 230px;\n    padding: 8px 10px;\n    border-radius: 8px;\n    background: #ffffff;\n    color: #0f172a;\n    border: 1px solid #e2e8f0;\n    font-size: 11px;\n    line-height: 1.4;\n    font-weight: 600;\n    text-align: left;\n    white-space: normal;\n    z-index: 8;\n    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.18);\n    pointer-events: none;\n}\n\n.otc-balance-tip__icon:hover .otc-balance-tip__text {\n    display: block;\n}\n\n.otc-inline-max-btn {\n    background: none;\n    border: none;\n    color: #D5A760;\n    font-size: 12px;\n    font-weight: 700;\n    cursor: pointer;\n    padding: 0;\n}\n\n.otc-inline-max-btn:hover {\n    text-decoration: underline;\n}\n\n.quote-input-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: rgb(255 255 255 / 10%);\n    box-shadow: inset 0 3px 7px rgb(0 0 0 / 15%);\n    border: 1px solid #686868;\n    border-radius: 50px;\n    padding: 0 14px;\n    height: 48px;\n    transition: border-color 0.2s ease;\n}\n\nbody.light_theme .quote-input-card {\n    background: rgb(0 0 0 / 5%);\n    border-color: #e7e7e7;\n    box-shadow: inset 0 3px 7px rgb(0 0 0 / 5%);\n}\n\n.quote-input-card:focus-within {\n    border-color: rgba(213, 167, 96, 0.5);\n}\n\n.quote-input-coin {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.otc-coin-label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    pointer-events: none;\n    user-select: none;\n}\n\n.quote-field-input {\n    border: none;\n    background: transparent;\n    font-size: 16px;\n    font-weight: 500;\n    color: #ffffff;\n    outline: none;\n    /* width: 100%; */\n    font-family: inherit;\n}\n\nbody.light_theme .quote-field-input {\n    color: #0f172a;\n}\n\n.quote-field-input::placeholder {\n    color: #ffffff;\n}\n\n.quote-field-error,\n.quote-field-warning,\n.quote-field-hint {\n    margin: 6px 8px 0;\n    font-size: 12px;\n    line-height: 1.4;\n}\n\n.quote-field-error {\n    color: #f07178;\n}\n\n.quote-field-warning {\n    color: #e6b450;\n}\n\nbody.light_theme .quote-field-warning {\n    color: #9a6b00;\n}\n\n.quote-field-hint {\n    color: #7A8293;\n}\n\n/* Rate Row */\n.quote-rate-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 15px;\n    margin: 14px 2px 20px;\n}\n\n.quote-rate-label {\n    color: #7A8293;\n    font-weight: 500;\n}\n\n.quote-rate-val {\n    color: #D8DCE6;\n    font-weight: 500;\n    font-family: inherit;\n}\n\nbody.light_theme .quote-rate-val {\n    color: #0f172a;\n}\n\n/* Submit Button */\n.otc-desk-closed {\n    margin: 0 0 12px;\n    color: #f0c674;\n    font-size: 13px;\n    line-height: 1.5;\n}\n\n.btn-request-quote {\n    width: 100%;\n    height: 50px;\n    background: #D1AA67;\n    color: #ffffff !important;\n    font-size: 17px;\n    font-weight: 600;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n    box-shadow: 0 4px 16px rgba(217, 168, 89, 0.25);\n    transition: all 0.25s ease;\n}\n\n.btn-request-quote:hover {\n    background: #C79545;\n    transform: translateY(-1px);\n    box-shadow: 0 6px 20px rgba(217, 168, 89, 0.35);\n    color: #ffffff !important;\n}\n\n.btn-request-quote:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n/* How It Works Steps */\n.works-steps-list {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    padding-top: 6px;\n}\n\n.works-step-item {\n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n}\n\n.works-step-num {\n    width: 36px;\n    height: 36px;\n    min-width: 36px;\n    border-radius: 50%;\n    background: rgb(209 170 103 / 20%);\n    /* border: 1px solid rgba(213, 167, 96, 0.35); */\n    color: #D1AA67;\n    font-size: 15px;\n    font-weight: 800;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.works-step-text h4 {\n    font-size: 18px;\n    font-weight: 700;\n    color: #ffffff;\n    margin: 0 0 3px 0;\n}\n\nbody.light_theme .works-step-text h4 {\n    color: #0f172a;\n}\n\n.works-step-text p {\n    max-width: 96%;\n    font-size: 15px;\n    color: #9CA3AF;\n    margin: 0;\n    line-height: 1.45;\n}\n\nbody.light_theme .works-step-text p {\n    color: #64748b;\n}\n\n/* ==========================================================================\n   3. WHY TRADE WITH AGCE OTC DESK?\n   ========================================================================== */\n\n.why-otc-section {\n    position: relative;\n    min-height: 638px;\n    z-index: 666;\n    display: flex;\n    align-items: center;\n    padding: 30px 0 35px;\n    background: url('../../../../public/images/otc-desk-img/otc_deskbg.jpg') no-repeat center bottom / cover;\n    overflow: hidden;\n}\n\nbody.light_theme .why-otc-section {\n    background: url('../../../../public/images/otc-desk-img/otc_deskbg_light.jpg') no-repeat center bottom / cover;\n}\n\n.why-otc-title {\n    font-size: 38px;\n    font-weight: 600;\n    color: #ffffff;\n    text-align: left;\n    margin: 0 0 26px 0;\n}\n\nbody.light_theme .why-otc-title {\n    color: #0f172a;\n}\n\n.why-otc-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 18px;\n}\n\n.why-otc-card {\n    background: rgb(255 255 255 / 10%);\n    border: 1px solid rgb(255 252 248 / 10%);\n    border-radius: 18px;\n    padding: 22px;\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    transition: transform 0.25s ease, border-color 0.25s ease;\n}\n\nbody.light_theme .why-otc-card {\n    background: rgb(0 0 0 / 5%);\n    border-color: #eff6fe;\n}\n\n.why-otc-card:hover {\n    transform: translateY(-3px);\n    border-color: rgba(213, 167, 96, 0.35);\n}\n\n.why-otc-icon-box {\n    width: 45px;\n    height: 45px;\n    min-width: 45px;\n    border-radius: 16px;\n    background: rgb(209 170 103 / 25%);\n    /* border: 1px solid rgba(213, 167, 96, 0.25); */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.why-otc-icon-box img {\n    width: 20px;\n    height: 20px;\n    object-fit: contain;\n}\n\n.why-otc-text h3 {\n    font-size: 15px;\n    font-weight: 700;\n    color: #ffffff;\n    margin: 0 0 5px 0;\n}\n\nbody.light_theme .why-otc-text h3 {\n    color: #0f172a;\n}\n\n.why-otc-text p {\n    font-size: 13.5px;\n    color: #AEAEAE;\n    line-height: 1.45;\n    margin: 0;\n}\n\nbody.light_theme .why-otc-text p {\n    color: #64748b;\n}\n\n/* ==========================================================================\n   4. BUILT FOR TRADES THAT NEED MORE THAN AN EXCHANGE SCREEN\n   ========================================================================== */\n\n.built-trades-section {\n    padding: 100px 0 75px;\n    background-color: #171B20;\n    position: relative;\n}\n\nbody.light_theme .built-trades-section {\n    background-color: #ffffff;\n}\n\n.built-trades-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 40px;\n    margin-bottom: 48px;\n}\n\n.built-trades-left {\n    flex: 1;\n    max-width: 790px;\n}\n\n.built-trades-heading {\n    font-size: 60px;\n    font-weight: 700;\n    color: #ffffff;\n    line-height: 1;\n    margin: 0 0 18px 0;\n}\n\nbody.light_theme .built-trades-heading {\n    color: #0f172a;\n}\n\n.built-trades-desc {\n    font-size: 21px;\n    color: #8493A8;\n    line-height: 1.6;\n    margin: 0;\n}\n\nbody.light_theme .built-trades-desc {\n    color: #64748b;\n}\n\n.built-trades-right {\n    max-width: 720px;\n    flex-shrink: 0;\n}\n\n.built-trades-img {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    border-radius: 14px;\n}\n\n.built-trades-features {\n    max-width: 1160px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 40px;\n}\n\n.built-feature-card {\n    background: transparent;\n    padding: 0;\n}\n\n.built-feature-icon-wrapper {\n    width: 60px;\n    margin-bottom: 5px;\n}\n\n.built-feature-icon-wrapper img {\n    object-fit: contain;\n}\n\n.built-feature-card h3 {\n    font-size: 18px;\n    font-weight: 500;\n    color: #ffffff;\n    margin: 0 0 6px 0;\n    line-height: 1.35;\n}\n\nbody.light_theme .built-feature-card h3 {\n    color: #0f172a;\n}\n\n.built-feature-card p {\n    font-size: 14px;\n    color: #8493A8;\n    line-height: 1.45;\n    margin: 0;\n}\n\nbody.light_theme .built-feature-card p {\n    color: #64748b;\n}\n\n/* ==========================================================================\n   5. RECENT COMPLETED TRADES TABLE\n   ========================================================================== */\n\n.recent-trades-section {\n    padding: 48px 0 80px;\n    background-color: #171B20;\n    position: relative;\n}\n\nbody.light_theme .recent-trades-section {\n    background-color: #fff;\n}\n\n.trades-header-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.trades-header-row h2 {\n    font-size: 38px;\n    font-weight: 600;\n    color: #ffffff;\n    margin: 0;\n}\n\nbody.light_theme .trades-header-row h2 {\n    color: #0f172a;\n}\n\n.view-all-link {\n    font-size: 14px;\n    color: #D1AA67;\n    text-decoration: none;\n    font-weight: 600;\n    transition: color 0.2s ease;\n}\n\n.view-all-link:hover {\n    color: #D5A760;\n    text-decoration: underline;\n}\n\n.otc-trades-empty {\n    margin: 0;\n    padding: 48px 16px;\n    text-align: center;\n    color: #9ca3af;\n    background: rgb(255 255 255 / 10%);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 16px;\n}\n\nbody.light_theme .otc-trades-empty {\n    color: #64748b;\n    background: rgb(0 0 0 / 5%);\n    border-color: #e2e8f0;\n}\n\n.otc-history-back {\n    display: inline-block;\n    margin-bottom: 8px;\n}\n\n.otc-history-count {\n    color: #9ca3af;\n    font-size: 14px;\n}\n\n.otc-history-pager {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 16px;\n    color: #d1d5db;\n    font-size: 13px;\n}\n\n.otc-history-pager button {\n    border: none;\n    background: #d1aa67;\n    color: #fff;\n    border-radius: 999px;\n    padding: 8px 16px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.otc-history-pager button:disabled {\n    opacity: 0.45;\n    cursor: default;\n}\n\n.trades-table-card {\n    background: rgb(255 255 255 / 10%);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 16px;\n    overflow: hidden;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\n}\n\nbody.light_theme .trades-table-card {\n    background: #ffffff;\n    border-color: #e2e8f0;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);\n}\n\n.trades-table {\n    width: 100%;\n    border-collapse: collapse;\n    text-align: left;\n}\n\n.trades-table th {\n    background: #464B52;\n    padding: 12px 22px;\n    font-size: 13px;\n    font-weight: 400;\n    color: #9CA3AF;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\nbody.light_theme .trades-table th {\n    background: #f8fafc;\n    color: #64748b;\n    border-bottom-color: #e2e8f0;\n}\n\n.trades-table td {\n    padding: 16px 22px;\n    font-size: 13px;\n    color: #dfdfdf;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    vertical-align: middle;\n}\n\n.trades-table td.trade-pair-cell {\n    color: #fff;\n    font-weight: 500;\n}\n\n.trades-table td.trade-total-cell {\n    color: #fff;\n    font-weight: 500;\n}\n\nbody.light_theme .trades-table td {\n    color: #0f172a;\n    border-bottom-color: #f1f5f9;\n}\n\n.trades-table tr:last-child td {\n    border-bottom: none;\n}\n\n.badge-trade-type {\n    display: inline-block;\n    padding: 2px 11px;\n    border-radius: 50px;\n    font-size: 13.5px;\n    font-weight: 700;\n    text-align: center;\n}\n\n.badge-trade-type.buy {\n    background-color: #D1FAE5;\n    color: #059669;\n}\n\n.badge-trade-type.sell {\n    background-color: #FEE2E2;\n    color: #DC2626;\n}\n\n/* ==========================================================================\n   CREATIVE DROPDOWN STYLING\n   ========================================================================== */\n\n.otc-pair-picker {\n    width: 100%;\n}\n\n.otc-pair-picker .creative-dropdown-wrapper,\n.otc-pair-picker .creative-dropdown-trigger {\n    width: 100%;\n}\n\n.otc-pair-picker .creative-dropdown-trigger {\n    justify-content: space-between;\n}\n\n.otc-pair-picker .creative-dropdown-menu {\n    width: 100%;\n    min-width: 100%;\n}\n\n.otc-landing-pair-btn {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 0;\n    background: transparent;\n    color: #fff;\n    font-size: 17px;\n    font-weight: 600;\n    padding: 2px 0;\n    cursor: pointer;\n}\n\n.otc-pair-picker .orderbook-table td {\n    font-size: 13px;\n}\n\nbody.light_theme .otc-landing-pair-btn {\n    color: #0f172a;\n}\n\n.otc-pair-picker {\n    position: relative;\n    overflow: visible;\n}\n\n.otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open {\n    position: absolute !important;\n    left: 0 !important;\n    right: auto !important;\n    top: calc(100% + 8px) !important;\n    margin: 0 !important;\n    width: min(440px, calc(100vw - 32px)) !important;\n    height: auto !important;\n    max-height: min(520px, calc(100vh - 160px)) !important;\n    overflow: auto !important;\n    display: flex !important;\n    flex-direction: column !important;\n    z-index: 100000 !important;\n    background-color: #2b313c;\n}\n\n.otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open .spotLists {\n    display: block !important;\n    height: auto !important;\n    min-height: 240px !important;\n    max-height: none !important;\n    max-width: none !important;\n    width: 100% !important;\n    overflow: visible !important;\n}\n\n.otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open .table-responsive {\n    min-height: 160px !important;\n    max-height: 320px !important;\n    height: auto !important;\n    overflow: auto !important;\n}\n\nbody.light_theme .otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open {\n    background-color: #f2f2f2;\n    border-color: #e7e7e7;\n}\n\nbody.light_theme .otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open .spotLists {\n    background: #f2f2f2;\n}\n\nbody.light_theme .otc-desk-page .otc-pair-picker .orderbook-table th {\n    background: #f2f2f2;\n}\n\n.otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open {\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: 16px;\n    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);\n    background: #171b20;\n}\n\n.otc-desk-page .otc-pair-picker .spot-list-search .ivu-input {\n    background: rgb(255 255 255 / 10%);\n    border: 1px solid #686868;\n    border-radius: 10px;\n}\n\n.otc-desk-page .otc-pair-picker .spot-list-search .ivu-input input {\n    color: #ffffff;\n}\n\n.otc-desk-page .otc-pair-picker .spot-list-search i,\n.otc-desk-page .otc-pair-picker ul.favorites_list_tabs li button {\n    color: #9ca3af;\n}\n\n.otc-desk-page .otc-pair-picker ul.favorites_list_tabs li button.active {\n    color: #ffffff;\n}\n\n.otc-desk-page .otc-pair-picker ul.favorites_list_tabs li button.active:before,\n.otc-desk-page .otc-pair-picker ul.favorites_list_tabs li button:before {\n    background-color: #d5a760;\n}\n\n.otc-desk-page .otc-pair-picker .orderbook-table th {\n    color: #9ca3af;\n    background: #171a20;\n}\n\n.otc-desk-page .otc-pair-picker .pair-color,\n.otc-desk-page .otc-pair-picker .orderbook-table td {\n    color: #ffffff;\n}\n\n.otc-desk-page .otc-pair-picker .tokensubcnt {\n    color: #9ca3af;\n}\n\n.otc-desk-page .otc-pair-picker .text-green {\n    color: #2bc287;\n}\n\n.otc-desk-page .otc-pair-picker .text-danger {\n    color: #f74b60;\n}\n\n.otc-desk-page .otc-pair-picker tr.active {\n    background: rgba(213, 167, 96, 0.12);\n}\n\n.otc-desk-page .otc-pair-picker .ri-star-fill {\n    color: #d5a760;\n}\n\nbody.light_theme .otc-desk-page .otc-pair-picker .spot-list-search .ivu-input {\n    background: rgb(0 0 0 / 4%);\n    border-color: #e7e7e7;\n}\n\nbody.light_theme .otc-desk-page .otc-pair-picker .spot-list-search .ivu-input input,\nbody.light_theme .otc-desk-page .otc-pair-picker .pair-color,\nbody.light_theme .otc-desk-page .otc-pair-picker .orderbook-table td,\nbody.light_theme .otc-desk-page .otc-pair-picker ul.favorites_list_tabs li button.active {\n    color: #0f172a;\n}\n\nbody.light_theme .otc-desk-page .otc-pair-picker .orderbook-table th,\nbody.light_theme .otc-desk-page .otc-pair-picker .tokensubcnt,\nbody.light_theme .otc-desk-page .otc-pair-picker ul.favorites_list_tabs li button {\n    color: #64748b;\n}\n\n.creative-dropdown-wrapper {\n    position: relative;\n    display: inline-block;\n    z-index: 20;\n}\n\n.creative-dropdown-wrapper.is-open {\n    z-index: 1000;\n}\n\n.creative-dropdown-trigger {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    border: none;\n    background: transparent;\n    outline: none;\n    cursor: pointer;\n    padding: 2px 4px 2px 0;\n    border-radius: 6px;\n}\n\n.coin-trigger-content {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.coin-symbol-text {\n    font-size: 17px;\n    font-weight: 600;\n    color: #ffffff;\n}\n\nbody.light_theme .coin-symbol-text {\n    color: #0f172a;\n}\n\n.dropdown-chevron {\n    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n    stroke: #c1c1c1;\n}\n\n.creative-dropdown-wrapper .dropdown-chevron path {\n    stroke: #c1c1c1;\n}\n\n.dropdown-chevron.rotate {\n    transform: rotate(180deg);\n    border: none;\n    width: auto;\n}\n\n.creative-dropdown-menu {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    min-width: 200px;\n    background-color: #1E232E !important;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 12px;\n    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5);\n    padding: 6px;\n    z-index: 99999 !important;\n    max-height: 260px;\n    overflow-y: auto;\n}\n\nbody.light_theme .creative-dropdown-menu {\n    background-color: #ffffff !important;\n    border-color: #e2e8f0;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n.creative-dropdown-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 10px;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.creative-dropdown-item:hover {\n    background-color: rgba(255, 255, 255, 0.08);\n}\n\nbody.light_theme .creative-dropdown-item:hover {\n    background-color: #f1f5f9;\n}\n\n.creative-dropdown-item.selected {\n    background-color: rgba(213, 167, 96, 0.15);\n}\n\n.dropdown-item-left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.coin-name-block {\n    display: flex;\n    flex-direction: column;\n}\n\n.coin-sym {\n    font-size: 13.5px;\n    font-weight: 700;\n    color: #ffffff;\n    line-height: 1.2;\n}\n\nbody.light_theme .coin-sym {\n    color: #0f172a;\n}\n\n.coin-subname {\n    font-size: 11.5px;\n    color: #7A8293;\n    font-weight: 500;\n}\n\n.otc-coin-icon-img {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n/* ==========================================================================\n   EXECUTION VIEW (/otc/rfq) PRESERVATION & ENHANCEMENTS\n   ========================================================================== */\n\n.otc-desk-trade {\n    padding: 8px 8px 16px;\n    min-height: calc(100vh - 58px);\n    background: #0b0e11;\n}\n\n.otc-trade-layout {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 360px;\n    grid-template-rows: 680px auto;\n    column-gap: 8px;\n    row-gap: 0;\n    align-items: start;\n}\n\n.otc-trade-chart {\n    height: 680px;\n    min-height: 680px;\n    max-height: 680px;\n    background: #0b0e11;\n    border-radius: 4px;\n    overflow: hidden;\n    position: relative;\n    border: 1px solid #1e2329;\n}\n\n.otc-desk-trade .otc-trade-chart #TVChartContainer,\n.otc-desk-trade .otc-trade-chart #TVChartContainer iframe {\n    height: 680px !important;\n    min-height: 680px !important;\n    max-height: 680px !important;\n    width: 100%;\n}\n\n.otc-trade-side {\n    grid-column: 2;\n    grid-row: 1 / span 2;\n    margin: 0;\n    max-height: calc(100vh - 80px);\n    overflow: auto;\n    border: 1px solid #1e2329;\n    border-radius: 4px;\n    background: #161a1e;\n    padding: 16px;\n}\n\n.otc-exec-title {\n    font-size: 16px;\n    margin-bottom: 12px;\n}\n\n.otc-current-ticket {\n    margin-top: 16px;\n    padding-top: 12px;\n    border-top: 1px solid #2b3139;\n}\n\n.otc-current-ticket h3 {\n    font-size: 14px;\n    margin: 0 0 10px;\n    color: #eaecef;\n}\n\n.otc-ticket-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 12px;\n    color: #848e9c;\n    padding: 6px 0;\n}\n\n.otc-ticket-row span:last-child {\n    color: #eaecef;\n    text-align: right;\n}\n\n.otc-bottom-panel {\n    grid-column: 1;\n    margin: 0;\n    background: #181a20;\n    border: 1px solid #1e2329;\n    border-radius: 4px;\n}\n\n.otc-bottom-head {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 16px;\n    border-bottom: 1px solid #2b3139;\n}\n\n.otc-bottom-tabs {\n    display: flex;\n    gap: 18px;\n    list-style: none;\n    margin: 0;\n    padding: 0 16px;\n    border-bottom: none;\n}\n\n.otc-bottom-tabs li button {\n    position: relative;\n    border: none;\n    background: transparent;\n    color: #848e9c;\n    font-size: 14px;\n    font-weight: 500;\n    padding: 14px 2px 12px;\n    cursor: pointer;\n}\n\n.otc-bottom-tabs li.active button {\n    color: #eaecef;\n}\n\n.otc-bottom-tabs li.active button::after {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    bottom: 0;\n    width: 28px;\n    height: 3px;\n    border-radius: 3px;\n    background: #D5A760;\n    transform: translateX(-50%);\n}\n\n.otc-bottom-note {\n    margin: 0 16px 12px 0;\n    font-size: 12px;\n    color: #848e9c;\n}\n\n.otc-bottom-empty {\n    display: flex;\n    align-items: center;\n    padding: 14px 16px;\n    color: #848e9c;\n    font-size: 13px;\n}\n\n.otc-bottom-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.otc-bottom-table th,\n.otc-bottom-table td {\n    padding: 10px 16px;\n    font-size: 12px;\n    text-align: left;\n    white-space: nowrap;\n}\n\n.otc-bottom-table th {\n    color: #848e9c;\n    font-weight: 500;\n    border-bottom: 1px solid #2b3139;\n}\n\n.otc-bottom-table td {\n    color: #eaecef;\n}\n\n.otc-bottom-table td.is-buy {\n    color: #20BF7A;\n}\n\n.otc-bottom-table td.is-sell {\n    color: #EF4444;\n}\n\n.otc-desk-status {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 999px;\n    background: #2b3139;\n    color: #eaecef;\n    font-size: 11px;\n}\n\n.otc-desk-status.is-open,\n.otc-desk-status.is-quoted {\n    background: rgba(213, 167, 96, 0.15);\n    color: #D5A760;\n}\n\n.otc-desk-status.is-accepted,\n.otc-desk-status.is-settled,\n.otc-desk-status.is-completed {\n    background: rgba(32, 191, 122, 0.15);\n    color: #20BF7A;\n}\n\n.otc-card-quote {\n    background: #181C26;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.otc-card-quote .otc-card-title {\n    color: #ffffff;\n    font-size: 18px;\n}\n\n.otc_tradingpage .midgraph_col .treade_card_header.tch_main_tab {\n    display: none;\n}\n\n.otc-quote-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 13px;\n    color: #848E9C;\n    padding: 4px 0;\n}\n\n.otc-quote-row span:last-child {\n    color: #ffffff;\n    font-weight: 600;\n}\n\n.otc-countdown {\n    font-size: 14px;\n    font-weight: 700;\n    color: #D5A760;\n    margin: 8px 0 16px;\n}\n\n.otc-countdown.expired {\n    color: #EF4444;\n}\n\n/* ==========================================================================\n   RESPONSIVE DESIGN\n   ========================================================================== */\n\n@media (max-width: 1550px) {\n\n\n    .otc-hero-badges-wrapper {\n        width: 700px;\n        height: 700px;\n        left: calc(50% - 350px);\n        top: 170px;\n    }\n\n    .otc-hero-title {\n        font-size: 54px;\n    }\n\n    .otc-hero-desc {\n        font-size: 21px;\n        max-width: 900px;\n    }\n\n    .otc-hero-btns a {\n        font-size: 18px;\n        padding: 12px 32px;\n    }\n\n    .otc-hero-btns a,\n    .otc-hero-btns button {\n        font-size: 18px;\n        padding: 12px 32px;\n        min-height: 54px;\n    }\n\n    .otc-suite-title {\n        font-size: 48px;\n    }\n\n    .otc-container {\n        width: 90%;\n    }\n\n    .built-trades-heading {\n        font-size: 48px;\n    }\n\n    .otc-hero-badge.badge-top {\n        top: 0px;\n        left: 50%;\n    }\n\n    .otc-hero-badge.badge-left {\n        left: calc(50% - 275px);\n        top: 130px;\n    }\n\n    .otc-hero-badge.badge-right {\n        left: calc(50% + 275px);\n        top: 130px;\n    }\n\n    .otc-hero-content {\n        margin-top: 340px;\n    }\n\n    .oct_bnr_img {\n        max-width: 1010px;\n    }\n}\n\n@media (max-width: 1200px) {\n    .otc_desk_hero_s {\n        background-size: 1400px auto;\n        min-height: 580px;\n    }\n\n    .otc-hero-badges-wrapper {\n        width: 580px;\n        height: 580px;\n        left: calc(50% - 290px);\n        top: 140px;\n    }\n\n    .otc-hero-badge.badge-top {\n        top: 0px;\n        left: 50%;\n    }\n\n    .otc-hero-badge.badge-left {\n        left: calc(50% - 225px);\n        top: 110px;\n    }\n\n    .otc-hero-badge.badge-right {\n        left: calc(50% + 225px);\n        top: 110px;\n    }\n\n    .otc-hero-content {\n        margin-top: 300px;\n    }\n\n    .otc-container {\n        width: 100%;\n        padding: 0 20px;\n    }\n\n    .why-otc-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .built-trades-left {\n        max-width: 100%;\n    }\n\n    .built-trades-desc {\n        margin: 0 auto;\n    }\n\n    .built-trades-section {\n        padding: 50px 0 60px;\n    }\n\n    .built-trades-heading {\n        font-size: 40px;\n    }\n\n    .built-trades-heading br {\n        display: none;\n    }\n\n    .built-trades-heading .gold-text {\n        display: inline;\n        padding-left: 8px;\n    }\n\n    .built-trades-features {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .otc-trading-suite-section {\n        padding: 50px 0 70px;\n    }\n\n    .why-otc-title {\n        font-size: 32px;\n    }\n\n    .oct_bnr_img {\n        max-width: 800px;\n    }\n\n    .otc-hero-title {\n        font-size: 44px;\n    }\n\n    .otc-hero-desc {\n        font-size: 18px;\n        max-width: 700px;\n    }\n\n    .otc-suite-title {\n        font-size: 38px;\n    }\n\n    .why-otc-section {\n        min-height: 490px;\n    }\n}\n\n@media (max-width: 1024px) {\n\n    .oct_bnr_img {\n        max-width: 600px;\n    }\n\n    .otc-hero-content {\n        margin-top: 200px;\n    }\n\n    .otc-hero-title {\n        font-size: 32px;\n    }\n\n    .otc-hero-desc {\n        font-size: 16px;\n        max-width: 530px;\n    }\n\n    .otc-hero-btns a {\n        font-size: 15px;\n        padding: 9px 26px;\n    }\n\n    .otc-hero-btns a,\n    .otc-hero-btns button {\n        font-size: 15px;\n        padding: 9px 26px;\n        min-height: 46px;\n    }\n\n    .otc_desk_hero_s {\n        background-size: contain;\n        min-height: 100%;\n    }\n\n    .otc-hero-badges-wrapper {\n        width: 450px;\n        height: 450px;\n        left: calc(50% - 226px);\n        top: 110px;\n    }\n\n    .otc-suite-title {\n        font-size: 32px;\n    }\n\n    .otc-card-title {\n        font-size: 24px;\n    }\n\n    .why-otc-title {\n        font-size: 26px;\n    }\n\n    .built-trades-heading {\n        font-size: 32px;\n    }\n\n    .built-trades-desc {\n        font-size: 16px;\n    }\n\n    .built-trades-right {\n        max-width: 450px;\n    }\n\n    .trades-header-row h2 {\n        font-size: 30px;\n    }\n\n}\n\n@media (max-width: 991px) {\n\n    .oct_bnr_img {\n        max-width: 450px;\n    }\n\n    .otc-landing-pair-btn {\n        font-size: 15px;\n    }\n\n    .quote-live-last {\n        font-size: 15px;\n    }\n\n    .coin-symbol-text {\n        font-size: 15px;\n    }\n\n    .quote-field-input {\n        font-size: 15px;\n    }\n\n    .otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open .spotLists {\n        top: 0px;\n        left: 0px;\n    }\n\n    .otc_desk_hero_s {\n        min-height: 100%;\n    }\n\n    .otc-hero-badges-wrapper {\n        width: 360px;\n        height: 360px;\n        left: calc(50% - 180px);\n        top: 70px;\n    }\n\n    .otc-hero-btns {\n        gap: 14px;\n        padding-top: 0px;\n    }\n\n    .otc-hero-badge {\n        width: 44px;\n        height: 44px;\n    }\n\n    .otc-hero-badge img {\n        width: 100%;\n        height: 100%;\n    }\n\n    .otc-hero-badge.badge-top {\n        top: 0px;\n        left: 50%;\n    }\n\n    .otc-hero-badge.badge-left {\n        left: calc(50% - 140px);\n        top: 65px;\n    }\n\n    .otc-hero-badge.badge-right {\n        left: calc(50% + 140px);\n        top: 65px;\n    }\n\n    .otc-hero-content {\n        margin-top: 140px;\n        margin-bottom: 60px;\n    }\n\n    .otc-hero-title {\n        font-size: 26px;\n    }\n\n\n    .built-feature-icon-wrapper {\n        margin: 0 auto 12px auto;\n    }\n\n    .built-trades-heading {\n        font-size: 26px;\n    }\n\n    .otc-suite-title {\n        font-size: 24px;\n    }\n\n    .trades-table-card {\n        border-radius: 12px;\n        overflow-x: auto;\n    }\n\n    .trades-table th,\n    .trades-table td {\n        padding: 12px 14px;\n        font-size: 13px;\n        white-space: nowrap;\n    }\n\n    .otc-trade-layout {\n        grid-template-columns: 1fr;\n        grid-template-rows: auto;\n    }\n\n    .otc-trade-side {\n        grid-column: 1;\n        grid-row: auto;\n        max-height: none;\n    }\n\n    .otc-bottom-panel {\n        grid-column: 1;\n    }\n\n    .otc-trade-chart,\n    .otc-desk-trade .otc-trade-chart #TVChartContainer,\n    .otc-desk-trade .otc-trade-chart #TVChartContainer iframe {\n        height: 420px !important;\n        min-height: 420px !important;\n        max-height: 420px !important;\n    }\n}\n\n@media (max-width: 767px) {\n\n    .why-otc-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .built-trades-features {\n        grid-template-columns: 1fr;\n        text-align: center;\n    }\n\n    .oct_bnr_img {\n        max-width: 80%;\n    }\n\n    .otc-hero-content {\n        margin-top: 40px;\n        margin-bottom: 30px;\n    }\n\n    .otc-hero-title {\n        font-size: 24px;\n    }\n\n    .otc-hero-desc {\n        font-size: 14px;\n        max-width: 530px;\n        margin: 15px auto 16px auto;\n    }\n\n    .otc-hero-btns a {\n        font-size: 14px;\n        padding: 9px 22px;\n    }\n\n    .otc-hero-btns a,\n    .otc-hero-btns button {\n        font-size: 14px;\n        padding: 9px 22px;\n        min-height: 38px;\n    }\n\n    .otc-trading-suite-section {\n        padding: 35px 0 30px;\n    }\n\n    .otc-suite-header {\n        margin-bottom: 18px;\n    }\n\n    .coin-symbol-text {\n        font-size: 13px;\n    }\n\n    .quote-field-input {\n        font-size: 13px;\n    }\n\n    .otc-card-title {\n        font-size: 20px;\n        margin: 0px 0px 12px;\n    }\n\n    .otc-card {\n        padding: 20px;\n    }\n\n    .quote-rate-row {\n        font-size: 13px;\n    }\n\n    .btn-request-quote {\n        height: 42px;\n        font-size: 14px;\n    }\n\n    .works-step-text h4 {\n        font-size: 16px;\n    }\n\n    .works-step-text p {\n        max-width: 100%;\n        font-size: 14px;\n    }\n\n    .why-otc-title {\n        font-size: 22px;\n        margin-bottom: 15px;\n        text-align: center;\n    }\n\n    .built-trades-top {\n        flex-direction: column;\n        gap: 18px;\n        margin-bottom: 20px;\n    }\n\n    .built-trades-left {\n        text-align: center;\n    }\n\n    .built-trades-heading {\n        font-size: 22px;\n    }\n\n    .built-trades-section {\n        padding: 30px 0 40px;\n    }\n\n    .built-feature-card h3 {\n        font-size: 16px;\n    }\n\n    .built-trades-features {\n        gap: 24px;\n    }\n\n    .trades-header-row h2 {\n        font-size: 22px;\n    }\n\n    .view-all-link {\n        font-size: 12px;\n        text-align: right;\n    }\n\n    .recent-trades-section {\n        padding: 30px 0 40px;\n    }\n\n    .otc-hero-badges-wrapper {\n        width: 270px;\n        height: 300px;\n        left: calc(50% - 133px);\n        top: 25px;\n    }\n\n    .quote-tab-pill {\n        font-size: 15px;\n    }\n\n    .otc_desk_hero_s::before {\n        width: 100%;\n        height: 120px;\n        bottom: -30px;\n        filter: blur(10px);\n    }\n\n    .otc_desk_hero_s {\n        background-size: cover;\n    }\n\n    .otc-quote-works-grid {\n        grid-template-columns: 1fr;\n        gap: 24px;\n    }\n\n}\n\n@media (max-width: 767px) {\n\n    .otc-suite-title {\n        font-size: 22px;\n    }\n\n}\n\n@media (max-width: 580px) {\n\n    .otc-desk-page .otc-pair-picker .trade_favourites_lft.is-open {\n        width: 280px !important;\n    }\n\n    .otc-landing-pair-btn {\n        font-size: 14px;\n    }\n\n    .quote-live-last {\n        font-size: 13px;\n    }\n\n    .quote-live-change {\n        font-size: 13px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
